
import { Routes, Route, Navigate } from 'react-router-dom';
import Intro from './pages/Intro';
import Invest from './pages/Invest';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/intro" replace />} />
      <Route path="/intro" element={<Intro />} />
      <Route path="/invest" element={<Invest />} />
    </Routes>
  );
}

export default App;
